
    import './styles.scoped.css';
    export default {
  "calendar": "awsui_calendar_mgja0_1nkdu_93",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_mgja0_1nkdu_1",
  "root": "awsui_root_mgja0_1nkdu_120",
  "focus-lock": "awsui_focus-lock_mgja0_1nkdu_156",
  "trigger-wrapper": "awsui_trigger-wrapper_mgja0_1nkdu_160",
  "trigger-flexbox": "awsui_trigger-flexbox_mgja0_1nkdu_164",
  "calendar-container": "awsui_calendar-container_mgja0_1nkdu_168",
  "one-grid": "awsui_one-grid_mgja0_1nkdu_171",
  "calendar-header": "awsui_calendar-header_mgja0_1nkdu_175",
  "calendar-header-months-wrapper": "awsui_calendar-header-months-wrapper_mgja0_1nkdu_181",
  "calendar-header-month": "awsui_calendar-header-month_mgja0_1nkdu_181",
  "calendar-next-month-btn": "awsui_calendar-next-month-btn_mgja0_1nkdu_200",
  "calendar-prev-month-btn": "awsui_calendar-prev-month-btn_mgja0_1nkdu_203",
  "first-grid": "awsui_first-grid_mgja0_1nkdu_207",
  "second-grid": "awsui_second-grid_mgja0_1nkdu_208",
  "date-and-time-container": "awsui_date-and-time-container_mgja0_1nkdu_212",
  "date-and-time-wrapper": "awsui_date-and-time-wrapper_mgja0_1nkdu_218",
  "footer": "awsui_footer_mgja0_1nkdu_225",
  "has-clear-button": "awsui_has-clear-button_mgja0_1nkdu_234",
  "footer-button-wrapper": "awsui_footer-button-wrapper_mgja0_1nkdu_243",
  "icon-wrapper": "awsui_icon-wrapper_mgja0_1nkdu_250",
  "label": "awsui_label_mgja0_1nkdu_255",
  "label-enabled": "awsui_label-enabled_mgja0_1nkdu_260",
  "label-text": "awsui_label-text_mgja0_1nkdu_264",
  "label-token-nowrap": "awsui_label-token-nowrap_mgja0_1nkdu_269",
  "mode-switch": "awsui_mode-switch_mgja0_1nkdu_273",
  "dropdown": "awsui_dropdown_mgja0_1nkdu_277",
  "dropdown-content": "awsui_dropdown-content_mgja0_1nkdu_299",
  "start-date-input": "awsui_start-date-input_mgja0_1nkdu_308",
  "start-time-input": "awsui_start-time-input_mgja0_1nkdu_309",
  "end-date-input": "awsui_end-date-input_mgja0_1nkdu_310",
  "end-time-input": "awsui_end-time-input_mgja0_1nkdu_311",
  "validation-section": "awsui_validation-section_mgja0_1nkdu_315",
  "validation-error": "awsui_validation-error_mgja0_1nkdu_319",
  "clear-button": "awsui_clear-button_mgja0_1nkdu_323",
  "apply-button": "awsui_apply-button_mgja0_1nkdu_327",
  "cancel-button": "awsui_cancel-button_mgja0_1nkdu_331",
  "calendar-aria-live": "awsui_calendar-aria-live_mgja0_1nkdu_335"
};
  